import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksAccountLineItemsSection', {
    colNameAccount: 'Category',
    colNameDescription: 'Description',
    colNameAmount: 'Amount',
    colNameLinked: 'Linked',
    colNameTaxCode: 'Tax',
    colNameCustomer: 'Customer',
    colNameClass: 'Class',
    colNameBillable: 'Billable',
    colNameTax: 'Tax',
    cellPlaceholderAccount: 'Select category',
    cellPlaceholderDescription: 'Enter a description',
    cellPlaceholderAmount: 'Enter the amount',
    cellPlaceholderTaxCode: 'Select Tax code',
    cellPlaceholderCustomer: 'Select a Customer',
    cellPlaceholderClass: 'Select a Class',
    headerText: 'Category details',
    lineAmountTypeLabel: 'Amounts are',
    groupEdit: 'Edit selected',
    groupClone: 'Clone selected',
    groupRemove: 'Remove selected',
    multipleAccountsWarning:
        '{contactDisplayName} {requestName} had multiple accounts in the past. Check suggested accounts.',
    multipleTaxCodesWarning:
        '{contactDisplayName} {requestName} had multiple tax rates in the past. Check suggested tax rate.',
    multipleCustomersWarning:
        '{contactDisplayName} {requestName} had multiple customers in the past. Check suggested customers.',
    multipleClassesWarning:
        '{contactDisplayName} {requestName} had multiple classes in the past. Check suggested classes.',
    differentAmountWarningDescription: 'Bill line amount differs from File line amount.',
    differentAmountWarningLabel1: 'Bill line amount:',
    differentAmountWarningLabel2: 'File line amount:',
});
